import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aed82826"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latex-container" }
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = { class: "flex-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Concise µGlyph", -1))
const _hoisted_5 = { class: "copy-button" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copy", -1))
const _hoisted_7 = {
  key: 2,
  class: "copied-text"
}
const _hoisted_8 = { class: "informations" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Informations:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, " To use this export, you need to download the sty file below. ", -1))
const _hoisted_11 = { class: "flex-center button-holder" }

import MicrogestureInput from '@/components/Microgesture/MicrogestureInput'
import microgestureToLatex from '@/components/Latex/microgestureToLatex'
import Toggle from '@/components/UI/ToggleComponent.vue'
import DownloadButton from '@/components/UI/DownloadButton'
import Latex from '@/components/Latex/LatexLogo.vue'
import { ref, watch } from 'vue'


export default {
  __name: 'LatexExportView',
  setup(__props) {

const microgesture = ref(undefined)
const displayText = ref(false)
const copied = ref(false)
const isConcise = ref(true)
const latex = ref(undefined)

function recomputeLatex () {
  latex.value = microgestureToLatex(microgesture.value, !isConcise.value)
}

function updateMicrogesture (newMicrogesture) {
  microgesture.value = newMicrogesture
  recomputeLatex()
}

watch(isConcise, recomputeLatex)

function copy () {
  const msg = microgestureToLatex(microgesture.value, !isConcise.value)
  copied.value = true
  const dummy = document.createElement('input')
  document.body.appendChild(dummy)
  dummy.setAttribute('id', 'dummy_id')
  document.getElementById('dummy_id').value = msg
  dummy.select()
  document.execCommand('copy')
  displayText.value = true
  setTimeout(() => {
    displayText.value = false
    copied.value = false
  }, 1200)
  document.body.removeChild(dummy)
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("h1", null, [
      _createVNode(Latex),
      _createTextVNode(" export")
    ]),
    _createVNode(_unref(MicrogestureInput), {
      "model-value": microgesture.value,
      "onUpdate:modelValue": updateMicrogesture,
      "allow-edit-button": false
    }, null, 8, ["model-value"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(latex.value), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(Toggle, {
          modelValue: isConcise.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((isConcise).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (!copied.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: copy
            }, [
              _createVNode(_component_unicon, { name: "copy" }),
              _hoisted_6,
              _createTextVNode(),
              _createVNode(Latex)
            ]))
          : (_openBlock(), _createBlock(_component_unicon, {
              key: 1,
              onClick: copy,
              name: "check"
            })),
        (displayText.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Copied!"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "copy-button",
        onClick: recomputeLatex
      }, [
        _createVNode(_component_unicon, { name: "sync" }),
        _createTextVNode("reload "),
        _createVNode(Latex)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("ul", null, [
        _hoisted_10,
        _createElementVNode("li", null, [
          _createTextVNode(" The "),
          _createVNode(Latex),
          _createTextVNode(" code below must be used in a mathematical environment ($ $). ")
        ]),
        _createElementVNode("li", null, [
          _createTextVNode("If you are using the draw glyph (for instance triangle or rectangle) or the object glyph (gear glyph), you must also download the draw glyph zip file. The folder contained in the zip file should be placed at the root of your "),
          _createVNode(Latex),
          _createTextVNode(" project.")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_unref(DownloadButton), {
        "file-path": '/files/microGlyph.sty',
        "file-name": 'microGlyph.sty'
      }, {
        default: _withCtx(() => [
          _createTextVNode("Download "),
          _createVNode(Latex),
          _createTextVNode(" package")
        ]),
        _: 1
      }, 8, ["file-path", "file-name"]),
      _createVNode(_unref(DownloadButton), {
        "file-path": '/files/customGlyph.zip',
        "file-name": 'customGlyph.zip'
      }, {
        default: _withCtx(() => [
          _createTextVNode("Download draw glyphs")
        ]),
        _: 1
      }, 8, ["file-path", "file-name"])
    ])
  ]))
}
}

}